export default "__VITE_ASSET__7c003fe5__"